import { render } from "./help-dialog-service-account.vue?vue&type=template&id=a47d9526"
import script from "./help-dialog-service-account.vue?vue&type=script&setup=true&lang=js"
export * from "./help-dialog-service-account.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/noon/help-dialog-service-account.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a47d9526"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a47d9526', __exports__)) {
    console.log('reload')
    api.reload('a47d9526', __exports__)
  }
  
  module.hot.accept("./help-dialog-service-account.vue?vue&type=template&id=a47d9526", () => {
    console.log('re-render')
    api.rerender('a47d9526', render)
  })

}


export default __exports__